import classnames from 'classnames';
import React from 'react';

import Actionable from 'root/widgets/common-components/actionable';

import 'root/widgets/hide-listing-nudge/hide-listing-nudge.scss';
import { HideListingNudgeHeaderProps } from 'root/widgets/hide-listing-nudge/types';

const HideListingNudgeHeader: React.FC<HideListingNudgeHeaderProps> = ({
  title,
  undoText,
  closeAction,
  undoAction,
}) => (
  <div className="hide-listing-nudge-header">
    <Actionable {...closeAction} className={classnames('close', closeAction.className)}>
      <i className="pgicon pgicon-cancel" />
    </Actionable>
    <div className="title">{title}</div>
    <Actionable {...undoAction} className={classnames('undo', undoAction.className)}>
      {undoText}
    </Actionable>
  </div>
);

export default HideListingNudgeHeader;
